import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[appInput]'
})
export class InputDirective {

  @HostBinding('class') class = 'border rounded-lg bg-grayscale-200 focus:outline-none focus:border focus:border-grayscale-400 font-montserrat leading-5 text-grayscale-900 pl-10 pr-4 py-2 mt-1';
}
